// extracted by mini-css-extract-plugin
module.exports = {"action":"index__action___2uPhx"};